"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Util_1 = require("../../../../../../../Services/Util");
var PackIdentifierFilter = /** @class */ (function (_super) {
    __extends(PackIdentifierFilter, _super);
    function PackIdentifierFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.search = function () {
            var _a, _b;
            var productCode = (_a = _this.productCodeInput.current) === null || _a === void 0 ? void 0 : _a.value;
            var serialNumber = (_b = _this.serialNumberInput.current) === null || _b === void 0 ? void 0 : _b.value;
            var state = __assign({}, _this.state);
            if (Util_1.isNullOrWhiteSpace(productCode)) {
                state.productCodeIsInvalid = true;
            }
            if (Util_1.isNullOrWhiteSpace(serialNumber)) {
                state.serialNumberIsInvalid = true;
            }
            if (state.productCodeIsInvalid || state.serialNumberIsInvalid) {
                _this.setState(state);
            }
            else {
                _this.props.fetchResults({
                    productCode: productCode,
                    serialNumber: serialNumber
                });
            }
        };
        _this.productCodeInput = React.createRef();
        _this.serialNumberInput = React.createRef();
        _this.state = {
            productCodeIsInvalid: false,
            serialNumberIsInvalid: false
        };
        return _this;
    }
    PackIdentifierFilter.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.Row, { style: { alignItems: "center" } },
            React.createElement(reactstrap_1.Col, null,
                React.createElement(reactstrap_1.InputGroup, { className: "mb-2" },
                    React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                        React.createElement(reactstrap_1.InputGroupText, null, this.props.resources.ProductCode)),
                    React.createElement(reactstrap_1.Input, { invalid: this.state.productCodeIsInvalid, innerRef: this.productCodeInput, onChange: function () { if (_this.state.productCodeIsInvalid) {
                            _this.setState(__assign(__assign({}, _this.state), { productCodeIsInvalid: false }));
                        } } }),
                    this.state.productCodeIsInvalid && React.createElement(reactstrap_1.FormFeedback, null, this.props.resources.Registration_Validation_RequiredField)),
                React.createElement(reactstrap_1.InputGroup, null,
                    React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                        React.createElement(reactstrap_1.InputGroupText, null, this.props.resources.SerialNumber)),
                    React.createElement(reactstrap_1.Input, { invalid: this.state.serialNumberIsInvalid, innerRef: this.serialNumberInput, onChange: function () { if (_this.state.serialNumberIsInvalid) {
                            _this.setState(__assign(__assign({}, _this.state), { serialNumberIsInvalid: false }));
                        } } }),
                    this.state.serialNumberIsInvalid && React.createElement(reactstrap_1.FormFeedback, null, this.props.resources.Registration_Validation_RequiredField))),
            React.createElement(reactstrap_1.Col, { xs: "auto", style: { display: "flex", justifyContent: "center", alignItems: "center" } },
                React.createElement(reactstrap_1.Button, { size: "lg", outline: true, color: "primary", onClick: this.search },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSearch })))));
    };
    return PackIdentifierFilter;
}(React.Component));
exports.PackIdentifierFilter = PackIdentifierFilter;
//# sourceMappingURL=PackIdentifierFilter.js.map